import { render, staticRenderFns } from "./ItemSubTypesFilters.vue?vue&type=template&id=54b7e162"
import script from "./ItemSubTypesFilters.vue?vue&type=script&lang=js"
export * from "./ItemSubTypesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports